import { useEditor, useNode } from "@craftjs/core";
import { ReactNode } from "react";
import Settings from "./Settings";

interface GridProps {
    columns?: number;
    rowGap?: number;
    columnGap?: number;
    children: ReactNode;
}

const Grid = ({ columns = 2, rowGap = 2, columnGap = 2, children }: Partial<GridProps>) => {
    const {
        connectors: { connect },
    } = useNode();

    const { enabled } = useEditor((state) => ({
        enabled: state.options.enabled,
    }));

    if (enabled && !children)
        return (
            <div ref={(ref) => connect(ref!)} className="w-full p-3 bg-gray-200 rounded animate-pulse">
                This is an empty grid, add content here.
            </div>
        );

    return (
        <div
            ref={(ref) => connect(ref!)}
            className="grid content-start"
            style={{
                gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
                rowGap: `calc(${rowGap} * 1.5rem)`,
                columnGap: `calc(${columnGap} * 1.5rem)`,
            }}
        >
            {children}
        </div>
    );
};

export default Grid;

Grid.craft = {
    displayName: "Grid",
    props: {
        columns: 2,
        rowGap: 2,
        columnGap: 2,
    },
    related: {
        settings: Settings,
    },
    rules: {
        canDrag: () => true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        canDrop: (targetNode: any) =>
            targetNode.data.name === "Div" ||
            targetNode.data.name === "Grid" ||
            targetNode.data.name === "PageContentContainer",
    },
};
